import { useTranslation } from "react-i18next";
import { Popover, Typography } from "@mui/material";

import { NotificationCategoryEnum } from "../../enums/notifications";

import NotificationsTabs from "./NotificationsTabs";
import NotificationsList from "./NotificationsList";

const NotificationsPopover = ({
  notificationsOpen,
  anchorEl,
  onClose,
  activeTab,
  setActiveTab,
  data,
  lastSeen,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: {
  notificationsOpen: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  activeTab: NotificationCategoryEnum;
  setActiveTab: (tab: NotificationCategoryEnum) => void;
  data: any;
  lastSeen?: number;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Popover
      open={notificationsOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        sx: styles.container,
      }}
    >
      <Typography
        variant="h5Bold"
        sx={{
          px: "24px",
        }}
      >
        {t("layout.notifications.notification")}
      </Typography>
      <NotificationsTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <NotificationsList
        data={data}
        lastSeen={lastSeen}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onClose={onClose}
      />
    </Popover>
  );
};

export default NotificationsPopover;

const styles = {
  container: {
    borderRadius: "8px",
    width: "400px",
    height: "60vh",
    display: "flex",
    flexDirection: "column",
    rowGap: "24px",
    background: "#FFF",
    padding: "24px 24px 24px 0",
    top: "83px !important",
  },
};
